import produce from 'immer';
import * as quoteActions from '../actions/quote';

import {
  CHANGE_ACTIVE_STORE_SUCCESS
} from '../actions/user';

import {
  RECEIVE_QUEUED_TASK_UPDATE
} from '../actions/products';


const initialState = {
  allQuoteProducts: [],
  quoteProducts: [],
  quoteProductsExport: [],
  quoteProductsByGroup: [],
  quoteProductsTemplates: null,
  quoteProPackagesData: {
    quotePackages: [],
    page: null,
    limit: null,
    count: null,
    totalCount: null,
    pages: null
  },
  quoteProductsCount: 0,
  quoteGroupsAttributeData: {
    options: []
  },
  quoteProductSubscriptionOptions: [],
  quotePlan: [],
  quotePlanSelectedSeriesIds: [],
  massEditList: [],
  currentCustomerQuoteId: null,
  currentCustomerQuoteData: null,
  currentQuoteCustomer: null,
  currentMarketingSegment: {
    label: '',
    value: '',
    total_count: 0
  },
  marketingSegmentsQuoteQueue: [],
  failedMarketingSegmentsQuoteQueue: [],
  countOfFailedQueueTasks: 0,
  countOfCreatedQueueTasks: 0,
  customerPushCart: null,
  activeMagentoCart: null,
  finalPageData: {
    items: [],
    expirationDate: null
  },
  patientsGroupCart: [],
  editableQuoteProduct: null,
  editableQuoteProductWithoutChanges: null,
  quoteProProductAttributeByCode: null,
  quoteCustomers: [],
  draftedQuotes: [],
  selectedDraftedQuote: {
    _id: '',
    subtotal: 0,
    discount: 0,
    amount: 0
  },
  quotePayTotals: null,
  quoteCartBillingAddress: null,
  quoteCartShippingAddress: null,
  quoteCartPaymentMethods: [],
  quoteCartShippingMethods: [],
  quoteCartSelectedShippingMethod: {
    carrier_code: '',
    method_code: ''
  },
  quoteCartStorePickUpMethods: [],
  customerAmastyQuotes: [],
  customerAmastyQuotesCount: 0,
  touchmdActivity: {
    items: [],
    pagination: {
      currentPage: 1,
      lastPage: 1,
      perPage: 20,
      total: 0,
    },
  },
  customerSubscription: [],
  quotePdfPreview: '',
  draftQuotePdfPreview: '',
  recentQuotePdfPreview: '',
  customerAccountTab: 'online_account',
  dealTasks: {},
  allTasks: [],
  tasksTotalCount: 0,
  dealActivities: {},
  allActivities: [],
  activitiesTotalCount: 0,
  TotalCount: 0,
  quoteCartTermsAndConditions: [],
  termsAndConditionsList: [],
  customersTotalCount: 0,
  subscriptionOptionsBySku: null,
  storeTimezone: 'America/Los_Angeles',
  loadingQuoteProductSubscriptionOptions: false,
  loadingQuoteCustomers: false,
  loadingFailedQueueTasks: false,
  savingCustomerAccount: false,
  quoteProductsLoading: false,
  quoteProductLoading: false,
  loadingQuoteProductsExport: false,
  quoteSubscriptionOptionsLoading: false,
  quoteGroupsLoading: false,
  savingProductLoading: false,
  loadingCustomerQuotes: false,
  loadingAddItemsToQuote: false,
  templatesLoading: false,
  saveTemplateLoading: false,
  packagesLoading: false,
  savePackageLoading: false,
  loadingTouchmdActivity: false,
  loadingDeleteQuoteItem: false,
  loadingConvertQuote: false,
  loadingQuoteTotals: false,
  loadingCheckout: false,
  loadingBillingAddress: false,
  loadingShippingAddress: false,
  settingBillingAddress: false,
  settingShippingAddress: false,
  loadingPaymentMethods: false,
  loadingShippingMethods: false,
  settingShippingMethods: false,
  loadingTermsAndConditions: false,
  loadingPlaceOrder: false,
  loadingQuoteProductAttributes: false,
  loadingSelectedShippingMethod: false,
  loadingCustomerPushCart: false,
  loadingPatientsGroupCart: false,
  loadingActiveMagentoCart: false,
  loadingCustomerSubscription: false,
  loadingCustomerAmastyQuotes: false,
  loadingQuotePdfPreview: false,
  loadingDraftedQuotes: false,
  loadingDraftQuotePdfPreview: false,
  loadingRecentQuotePdfPreview: false,
  loadingDraftQuotePdfDownload: false,
  loadingRecentQuotePdfDownload: false,
  loadingQuotePdfDownload: false,
  loadingTimezoneConfig: false,
  isPackageDeleting: false,
  loadingDealTasks: false,
  loadingDealActivities: false,
  loadingMarketingSegmentsQueue: false
};

const formReducer = produce((state: IQuoteState = initialState, action) => {
  switch (action.type) {
    case quoteActions.GET_QUOTE_CUSTOMERS_GRID_START: {
      state.loadingQuoteCustomers = true;
      break;
    }

    case quoteActions.GET_QUOTE_CUSTOMERS_GRID_SUCCESS: {
      const {data: {customers: {items, total_count}}} = action;

      state.quoteCustomers = items;
      state.customersTotalCount = total_count;
      state.loadingQuoteCustomers = false;
      break;
    }

    case quoteActions.GET_QUOTE_CUSTOMERS_GRID_FAILED: {
      state.loadingQuoteCustomers = false;
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.quoteCustomers = initialState.quoteCustomers;
      state.customersTotalCount = initialState.customersTotalCount;
      state.allQuoteProducts = initialState.allQuoteProducts;
      state.quoteProducts = initialState.quoteProducts;
      state.quoteProductsByGroup = initialState.quoteProductsByGroup;
      state.quoteGroupsAttributeData = initialState.quoteGroupsAttributeData;
      state.currentMarketingSegment = initialState.currentMarketingSegment;
      state.finalPageData = initialState.finalPageData;
      state.patientsGroupCart = initialState.patientsGroupCart;
      state.marketingSegmentsQuoteQueue = initialState.marketingSegmentsQuoteQueue;
      state.quoteProPackagesData = initialState.quoteProPackagesData;
      // state.quoteStages = initialState.quoteStages;
      // state.analiticsQuotes = initialState.analiticsQuotes;
      // state.analiticsQuotesTotal = initialState.analiticsQuotesTotal;
      break;
    }

    case quoteActions.GET_QUOTE_CUSTOMERS_GRID_SUCCESS: {
      const {data: {customers: {items, total_count}}} = action;

      state.quoteCustomers = items;
      state.customersTotalCount = total_count;
      state.loadingQuoteCustomers = false;
      break;
    }

    case quoteActions.GET_QUOTE_CUSTOMERS_GRID_FAILED: {
      state.loadingQuoteCustomers = false;
      break;
    }

    case quoteActions.GET_QUOTE_CUSTOMER_START: {
      state.loadingQuoteCustomers = true;
      break;
    }

    case quoteActions.GET_QUOTE_CUSTOMER_SUCCESS: {
      const {customer} = action.data;

      state.currentQuoteCustomer = customer;
      state.loadingQuoteCustomers = false;
      break;
    }

    case quoteActions.GET_QUOTE_CUSTOMER_FAILED: {
      state.loadingQuoteCustomers = false;
      break;
    }

    case quoteActions.CREATE_QUOTEPRO_CUSTOMER_START: {
      state.savingCustomerAccount = true;
      break;
    }
    case quoteActions.CREATE_QUOTEPRO_CUSTOMER_SUCCESS: {
      const {data: {customer}} = action;

      state.quoteCustomers = [customer, ...state.quoteCustomers];
      state.savingCustomerAccount = false;
      break;
    }
    case quoteActions.CREATE_QUOTEPRO_CUSTOMER_FAILED: {
      state.savingCustomerAccount = false;
      break;
    }

    case quoteActions.UPDATE_QUOTE_CUSTOMER_START: {
      state.savingCustomerAccount = true;
      break;
    }
    case quoteActions.UPDATE_QUOTE_CUSTOMER_SUCCESS: {
      const {data: {customer}} = action;

      state.quoteCustomers = state.quoteCustomers.map((user) => user.id === customer.id ? customer : user);
      state.savingCustomerAccount = false;
      break;
    }
    case quoteActions.UPDATE_QUOTE_CUSTOMER_FAILED: {
      state.savingCustomerAccount = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_PRODUCTS_START: {
      state.quoteProductsLoading = true;
      break;
    }

    case quoteActions.GET_QUOTEPRO_PRODUCTS_SUCCESS: {
      const { products: { productsList, count } } = action;

      state.allQuoteProducts = productsList;

      // Existing logic for quoteProducts and quoteProductsByGroup
      state.quoteProducts = productsList;
      state.quoteProductsByGroup = productsList
        .sort((a, b) => a.name.localeCompare(b.name))
        .reduce((acc, product) => {
          const isInOffice = product.custom_attributes?.find((attr) => attr.attribute_code === 'isoffice')?.value === '1' || false;
          const isInStock = product.extension_attributes?.stock_item?.is_in_stock || false;

          // Skip all inactive, in office, and not in stock products for quoteProductsByGroup
          if (product.status != 1 || !isInStock || isInOffice) {
            return acc;
          }

          const productGroupsIds = product.custom_attributes?.find(
            (attr) => attr.attribute_code === 'catalog_quotepro_groups'
          )?.value || [];

          if (productGroupsIds.length) {
            const groups = productGroupsIds.split(',');
            groups.forEach((groupValue) => {
              acc = {
                ...acc,
                [groupValue]: acc[groupValue]
                  ? [...acc[groupValue], product]
                  : [product]
              };
            });
          }

          acc['All'] = acc['All'] ? [...acc['All'], product] : [product];

          return acc;
        }, {});

      state.quoteProductsCount = count;
      state.quoteProductsLoading = false;

      break;
    }


    case quoteActions.GET_QUOTEPRO_PRODUCTS_FAILED: {
      state.quoteProductsLoading = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_START: {
      state.quoteProductsLoading = true;
      break;
    }

    case quoteActions.GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_SUCCESS: {
      const {products: {items, total_count}} = action;

      const uniqueSkus = new Set(state.quoteProducts.map((product) => product.sku));
      const updatedQuoteProducts = items.reduce((acc, product) => {
        if (!uniqueSkus.has(product.sku)) {
          acc.push(product);
          uniqueSkus.add(product.sku);
        }

        return acc;
      }, [...state.quoteProducts]);

      const updatedQuoteProductsByGroup = items
        .sort((a, b) => a.name.localeCompare(b.name))
        .reduce((acc, product) => {
          const productGroupsIds = product.custom_attributes?.find(
            (attr) => attr.attribute_code === 'catalog_quotepro_groups'
          )?.value || [];

          if (productGroupsIds.length) {
            const groups = productGroupsIds.split(',');
            groups.forEach((groupValue) => {
              if (!acc[groupValue]) {
                acc[groupValue] = [];
              }

              const isProductInGroup = acc[groupValue].some((p) => p.sku === product.sku);

              if (!isProductInGroup) {
                acc[groupValue].push(product);
              }
            });
          }

          return acc;
        }, { ...state.quoteProductsByGroup });

      updatedQuoteProductsByGroup['All'] = updatedQuoteProducts;

      state.quoteProducts = updatedQuoteProducts;
      state.quoteProductsByGroup = updatedQuoteProductsByGroup;
      state.quoteProductsCount = state.quoteProductsCount + total_count;
      state.quoteProductsLoading = false;

      break;
    }

    case quoteActions.GET_QUOTEPRO_PRODUCTS_BY_SEARCH_CRITERIA_FAILED: {
      state.quoteProductsLoading = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_PACKAGES_START: {
      state.packagesLoading = true;
      break;
    }

    case quoteActions.GET_QUOTEPRO_PACKAGES_SUCCESS: {
      state.quoteProPackagesData = action.data;
      state.packagesLoading = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_PACKAGES_FAILED: {
      state.packagesLoading = false;
      break;
    }

    case quoteActions.DELETE_QUOTEPRO_PACKAGE_START: {
      state.isPackageDeleting = true;
      break;
    }

    case quoteActions.DELETE_QUOTEPRO_PACKAGE_SUCCESS: {
      state.quoteProPackagesData.quotePackages = state.quoteProPackagesData?.quotePackages?.filter((p) => p._id !== action.id);
      state.isPackageDeleting = false;
      break;
    }

    case quoteActions.DELETE_QUOTEPRO_PACKAGE_FAILED: {
      state.isPackageDeleting = false;
      break;
    }

    case quoteActions.CREATE_QUOTEPRO_PACKAGE_START: {
      state.savePackageLoading = true;
      break;
    }

    case quoteActions.CREATE_QUOTEPRO_PACKAGE_SUCCESS: {
      const {limit, totalCount, quotePackages} = state.quoteProPackagesData;

      state.quoteProPackagesData['quotePackages'].unshift(action.data);

      if (quotePackages.length === limit) {
        //remove last to have correct pagination count
        state.quoteProPackagesData['quotePackages'].shift();
      }

      state.quoteProPackagesData['totalCount'] = totalCount + 1;
      state.quoteProPackagesData['pages'] = Math.ceil((totalCount + 1) / limit);
      state.savePackageLoading = false;
      break;
    }

    case quoteActions.CREATE_QUOTEPRO_PACKAGE_FAILED: {
      state.savePackageLoading = false;
      break;
    }

    case quoteActions.GET_QUOTE_PRODUCT_START: {
      state.quoteProductLoading = true;
      break;
    }

    case quoteActions.GET_QUOTE_PRODUCT_SUCCESS: {
      const { productData } = action;

      state.editableQuoteProduct = productData;
      state.editableQuoteProductWithoutChanges = productData;
      state.quoteProductLoading = false;
      break;
    }

    case quoteActions.GET_QUOTE_PRODUCT_FAILED: {
      state.quoteProductLoading = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_PRODUCTS_EXPORT_START: {
      state.loadingQuoteProductsExport = true;
      break;
    }

    case quoteActions.GET_QUOTEPRO_PRODUCTS_EXPORT_SUCCESS: {
      const {data} = action;
      state.quoteProductsExport = data.data;
      state.loadingQuoteProductsExport = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_PRODUCTS_EXPORT_FAILED: {
      state.loadingQuoteProductsExport = false;
      break;
    }

    case RECEIVE_QUEUED_TASK_UPDATE: {
      const { action: taskAction, task, resultData, task: {storeViewCode} } = action.data;

      const isQuoteProStore = storeViewCode.includes('quote');

      if (taskAction === 'TASK_COMPLETED' && isQuoteProStore) {
        if (task.requestType === 'CREATE_PRODUCT' ||
         task.requestType === 'UPDATE_PRODUCT_TO_ADD_STOREVIEW') {
          state.quoteProducts = [resultData, ...state.quoteProducts];
        } else if (task.requestType === 'UPDATE_PRODUCT') {
          state.quoteProducts = state.quoteProducts.map((p) => p.sku === resultData.sku ? resultData : p);

          if (resultData.sku === state.editableQuoteProduct?.sku) {
            state.editableQuoteProduct = resultData;
          }

          const groups = resultData.custom_attributes.find((attr) => attr.attribute_code === 'catalog_quotepro_groups')?.value.split(',') || [];
          groups.forEach((groupId) => {
            if (state.quoteProductsByGroup[groupId]) {
              state.quoteProductsByGroup[groupId] = state.quoteProductsByGroup[groupId].map((p) => p.sku === resultData.sku ? resultData : p);
            }
          });
        } else if (task.requestType === 'DELETE_PRODUCT' ||
         task.requestType === 'UPDATE_PRODUCT_TO_DELETE_STOREVIEW') {
          state.quoteProducts = state.quoteProducts.filter((p) => p.sku !== task.sku);
        }

        if (state.subscriptionOptionsBySku?.[resultData.sku]) {
          Reflect.deleteProperty(state.subscriptionOptionsBySku, resultData.sku);
        }
      }

      if (
        taskAction === 'TASK_COMPLETED' && !isQuoteProStore &&
        (task.requestType === 'UPDATE_PRODUCT_TO_ADD_STOREVIEW' ||
         task.requestType === 'UPDATE_PRODUCT_TO_DELETE_STOREVIEW')
      ) {
        state.quoteProducts = state.quoteProducts.map((p) => {
          if (p.sku === resultData.sku) {
            const updatedProductWebsiteIds = resultData.extension_attributes.website_ids;
            return {...p, extension_attributes: { ...p.extension_attributes, website_ids: updatedProductWebsiteIds }};
          }

          return p;
        });
      }

      break;
    }

    case quoteActions.GET_QUOTEPRO_GROUPS_ATTRIBUTE_START: {
      state.quoteGroupsLoading = true;
      break;
    }

    case quoteActions.GET_QUOTEPRO_GROUPS_ATTRIBUTE_SUCCESS: {
      //TODO: fix backend, API response comes with empty object props {label: ' ', value: ''}
      const { attributeData = {} } = action;

      const updatedOptions = [
        ...attributeData.options.filter((o) => o.value !== ''),
        { label: 'All', value: 'All' },
      ];

      state.quoteGroupsAttributeData = {
        ...attributeData,
        options: updatedOptions,
      };
      state.quoteGroupsLoading = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_GROUPS_ATTRIBUTE_FAILED: {
      state.quoteGroupsLoading = false;
      break;
    }

    case quoteActions.UPDATE_QUOTEPRO_PRODUCT_GROUPS: {
      const isAttrGroupsExist = !!state.editableQuoteProduct['custom_attributes']
        .filter((attr) => attr.attribute_code === 'catalog_quotepro_groups').length;

      state.editableQuoteProduct['custom_attributes'] = isAttrGroupsExist ?
        state.editableQuoteProduct['custom_attributes']
          .map((attr) => attr.attribute_code === 'catalog_quotepro_groups'
            ? {...attr, value: action.groupIds}
            : attr
          )
        :
        [
          ...state.editableQuoteProduct['custom_attributes'],
          {
            attribute_code: 'catalog_quotepro_groups',
            value: action.groupIds
          }
        ];
      break;
    }

    case quoteActions.UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_START: {
      state.quoteGroupsLoading = true;
      break;
    }

    case quoteActions.UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_SUCCESS: {
      state.quoteGroupsAttributeData = action.attributeData;
      state.quoteGroupsLoading = false;
      break;
    }

    case quoteActions.UPDATE_QUOTEPRO_GROUPS_ATTRIBUTE_FAILED: {
      state.quoteGroupsLoading = false;
      break;
    }

    case quoteActions.UPDATE_QUOTEPRO_LISTINGS_START: {
      state.savingProductLoading = true;
      break;
    }

    case quoteActions.UPDATE_QUOTEPRO_LISTINGS_SUCCESS: {
      const {result} =  action.product;

      const baseImageValue = result.media_gallery_entries.find((media) => media.types.includes('image'))?.file || '';
      const baseSmallImageValue = result.media_gallery_entries.find((media) => media.types.includes('small_image'))?.file || '';
      const baseThumbnailValue = result.media_gallery_entries.find((media) => media.types.includes('thumbnail'))?.file || '';

      const customAttributes = result.custom_attributes.map((attr) => {
        if (attr.attribute_code === 'image') {
          return {...attr, value: baseImageValue};
        }

        if (attr.attribute_code === 'small_image') {
          return {...attr, value: baseSmallImageValue};
        }

        if (attr.attribute_code === 'thumbnail') {
          return {...attr, value: baseThumbnailValue};
        }

        return attr;
      });

      state.editableQuoteProduct = {
        ...state.editableQuoteProduct,
        custom_attributes: customAttributes,
        media_gallery_entries: result.media_gallery_entries
      };

      state.savingProductLoading = false;
      break;
    }

    case quoteActions.UPDATE_QUOTEPRO_LISTINGS_FAILED: {
      state.savingProductLoading = false;
      break;
    }

    case quoteActions.SET_QUOTE_CUSTOMER_DATA: {
      state.customerSubscription = initialState.customerSubscription;
      state.quoteCustomers = initialState.quoteCustomers;
      state.currentQuoteCustomer = initialState.currentQuoteCustomer;
      state.customersTotalCount = initialState.customersTotalCount;
      state.customerAccountTab = initialState.customerAccountTab;
      state.customerAmastyQuotes = initialState.customerAmastyQuotes;
      state.currentQuoteCustomer = action.customer;
      break;
    }

    case quoteActions.SET_QUOTE_CUSTOMER_ACCOUNT_TAB: {
      state.customerAccountTab = action.tab;
      break;
    }

    case quoteActions.SET_QUOTE_MARKETING_SEGMENT_DATA: {
      state.customerPushCart = initialState.customerPushCart;
      state.currentMarketingSegment = action.group;
      break;
    }


    case quoteActions.GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START: {
      state.loadingMarketingSegmentsQueue = true;
      break;
    }

    case quoteActions.GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS: {
      state.marketingSegmentsQuoteQueue = action.data.data;
      state.countOfCreatedQueueTasks = action.data.total_items;
      state.loadingMarketingSegmentsQueue = false;
      break;
    }

    case quoteActions.GET_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED: {
      state.loadingMarketingSegmentsQueue = false;
      break;
    }

    case quoteActions.GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START: {
      state.loadingFailedQueueTasks = true;
      break;
    }

    case quoteActions.GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS: {
      state.failedMarketingSegmentsQuoteQueue = action.data.data;
      state.countOfFailedQueueTasks = action.data.total_items;
      state.loadingFailedQueueTasks = false;
      break;
    }

    case quoteActions.GET_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED: {
      state.loadingFailedQueueTasks = false;
      break;
    }

    case quoteActions.DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_START: {
      state.loadingFailedQueueTasks = true;
      break;
    }

    case quoteActions.DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_SUCCESS: {
      state.failedMarketingSegmentsQuoteQueue = state.failedMarketingSegmentsQuoteQueue
        .filter((task) => task._id !== action.id);
      state.loadingFailedQueueTasks = false;
      break;
    }

    case quoteActions.DELETE_FAILED_MARKETING_SEGMENTS_QUOTE_QUEUE_TASKS_FAILED: {
      state.loadingFailedQueueTasks = false;
      break;
    }

    case quoteActions.DELETE_MARKETING_SEGMENTS_QUEUE_TASK_START: {
      state.loadingMarketingSegmentsQueue = true;
      break;
    }

    case quoteActions.DELETE_MARKETING_SEGMENTS_QUEUE_TASK_SUCCESS: {
      state.marketingSegmentsQuoteQueue = state.marketingSegmentsQuoteQueue
        .filter((task) => task._id !== action.id);
      state.loadingMarketingSegmentsQueue = false;
      break;
    }

    case quoteActions.DELETE_MARKETING_SEGMENTS_QUEUE_TASK_FAILED: {
      state.loadingMarketingSegmentsQueue = false;
      break;
    }


    case quoteActions.RECEIVE_MARKETING_SEGMENT_QUOTE_QUEUE_TASK_UPDATE: {
      const {action: taskAction, task} = action.data;

      if (taskAction === 'QUOTE_TASK_COMPLETED') {
        state.marketingSegmentsQuoteQueue = state.marketingSegmentsQuoteQueue
          .filter((t) => t._id !== task._id);
      }

      if (taskAction === 'QUOTE_TASK_UPDATED' && task.status === 'FAILED') {
        state.marketingSegmentsQuoteQueue = state.marketingSegmentsQuoteQueue
          .map((t) => t._id == task._id ? task : t);
      }

      break;
    }

    case quoteActions.GET_QUOTE_ITEMS_COMBINED_START: {
      state.loadingCustomerQuotes = true;
      break;
    }

    case quoteActions.GET_QUOTE_ITEMS_COMBINED_SUCCESS: {
      const {data} = action;

      state.currentCustomerQuoteData = data;
      state.loadingCustomerQuotes = false;
      break;
    }


    case quoteActions.GET_QUOTE_ITEMS_COMBINED_FAILED: {
      state.loadingCustomerQuotes = false;
      break;
    }

    case quoteActions.GET_CUSTOMER_AMASTY_QUOTES_START: {
      state.loadingCustomerAmastyQuotes = true;
      break;
    }

    case quoteActions.GET_CUSTOMER_AMASTY_QUOTES_SUCCESS: {
      const {data, quotesCount} = action;

      state.customerAmastyQuotes = data;
      state.customerAmastyQuotesCount = quotesCount;
      state.loadingCustomerAmastyQuotes = false;
      break;
    }

    case quoteActions.GET_CUSTOMER_AMASTY_QUOTES_FAILED: {
      state.loadingCustomerAmastyQuotes = false;
      break;
    }

    case quoteActions.ADD_ITEMS_TO_QUOTE_START: {
      state.loadingAddItemsToQuote = true;
      break;
    }

    case quoteActions.ADD_ITEMS_TO_QUOTE_SUCCESS: {
      const {data: {procedure}} = action;
      state.currentCustomerQuoteData = {
        ...state.currentCustomerQuoteData,
        items: procedure
      };
      state.loadingAddItemsToQuote = false;
      break;
    }

    case quoteActions.ADD_ITEMS_TO_QUOTE_FAILED: {
      state.loadingAddItemsToQuote = false;
      break;
    }

    case quoteActions.DELETE_QUOTE_ITEM_START: {
      state.loadingDeleteQuoteItem = true;
      break;
    }

    case quoteActions.DELETE_QUOTE_ITEM_SUCCESS: {
      const {itemId} = action;

      state.currentCustomerQuoteData.items = state.currentCustomerQuoteData.items
        .filter((item) => item.item_id !== itemId);

      state.loadingDeleteQuoteItem = false;
      break;
    }

    case quoteActions.DELETE_QUOTE_ITEM_FAILED: {
      state.loadingDeleteQuoteItem = false;
      break;
    }

    case quoteActions.CONVERT_QUOTE_START: {
      state.loadingConvertQuote = true;
      break;
    }

    case quoteActions.CONVERT_QUOTE_SUCCESS: {
      state.loadingConvertQuote = false;
      break;
    }

    case quoteActions.CONVERT_QUOTE_FAILED: {
      state.loadingConvertQuote = false;
      break;
    }

    case quoteActions.CLEAR_EDITABLE_QUOTE_PRODUCT_DATA: {
      state.editableQuoteProduct = initialState.editableQuoteProduct;
      state.quoteProductSubscriptionOptions = initialState.quoteProductSubscriptionOptions;
      break;
    }

    case quoteActions.GET_TOUCHMD_ACTIVITY_START: {
      state.loadingTouchmdActivity = true;
      break;
    }
    case quoteActions.GET_TOUCHMD_ACTIVITY_SUCCESS: {
      const {data, page, pages, totalCount} = action.data;

      state.touchmdActivity = {
        pagination: {
          currentPage: page,
          lastPage: pages,
          total: totalCount,
        },
        items: data,
      };
      state.loadingTouchmdActivity = false;
      break;
    }
    case quoteActions.GET_TOUCHMD_ACTIVITY_FAILED: {
      state.loadingTouchmdActivity = false;
      break;
    }

    case quoteActions.GET_QUOTE_TOTALS_START: {
      state.loadingQuoteTotals = true;
      break;
    }

    case quoteActions.GET_QUOTE_TOTALS_SUCCESS: {
      state.quotePayTotals = action.data;
      state.loadingQuoteTotals = false;
      break;
    }

    case quoteActions.GET_QUOTE_TOTALS_FAILED: {
      state.loadingQuoteTotals = false;
      break;
    }

    case quoteActions.OPEN_CHECKOUT_START: {
      state.loadingCheckout = true;
      break;
    }

    case quoteActions.OPEN_CHECKOUT_SUCCESS: {
      state.loadingCheckout = false;
      const { checkoutUrl } = action.data;
      window.location.href = checkoutUrl;
      break;
    }

    case quoteActions.OPEN_CHECKOUT_FAILED: {
      state.loadingCheckout = false;
      break;
    }

    case quoteActions.GET_QUOTE_CART_BILLING_ADDRESS_START: {
      state.loadingBillingAddress = true;
      break;
    }

    case quoteActions.GET_QUOTE_CART_BILLING_ADDRESS_SUCCESS: {
      state.quoteCartBillingAddress = action.data;
      state.loadingBillingAddress = false;
      break;
    }

    case quoteActions.GET_QUOTE_CART_BILLING_ADDRESS_FAILED: {
      state.loadingBillingAddress = false;
      break;
    }

    case quoteActions.SET_QUOTE_CART_BILLING_ADDRESS_START: {
      state.settingBillingAddress = true;
      break;
    }

    case quoteActions.SET_QUOTE_CART_BILLING_ADDRESS_SUCCESS: {
      state.settingBillingAddress = false;
      break;
    }

    case quoteActions.SET_QUOTE_CART_BILLING_ADDRESS_FAILED: {
      state.settingBillingAddress = false;
      break;
    }

    case quoteActions.GET_QUOTE_CART_SHIPPING_ADDRESS_START: {
      state.loadingShippingAddress = true;
      break;
    }

    case quoteActions.GET_QUOTE_CART_SHIPPING_ADDRESS_SUCCESS: {
      state.quoteCartShippingAddress = action.data;
      state.loadingShippingAddress = false;
      break;
    }

    case quoteActions.GET_QUOTE_CART_SHIPPING_ADDRESS_FAILED: {
      state.loadingShippingAddress = false;
      break;
    }

    case quoteActions.CLEANUP_PAY_ADDRESSES_DATA: {
      state.quoteCartShippingAddress = initialState.quoteCartShippingAddress;
      state.quoteCartBillingAddress = initialState.quoteCartBillingAddress;
      state.quoteCartPaymentMethods = initialState.quoteCartPaymentMethods;
      state.quoteCartShippingMethods = initialState.quoteCartShippingMethods;
      break;
    }

    case quoteActions.SET_QUOTE_CART_SHIPPING_ADDRESS_START: {
      state.settingShippingAddress = true;
      break;
    }

    case quoteActions.SET_QUOTE_CART_SHIPPING_ADDRESS_SUCCESS: {
      state.settingShippingAddress = false;
      break;
    }

    case quoteActions.SET_QUOTE_CART_SHIPPING_ADDRESS_FAILED: {
      state.settingShippingAddress = false;
      break;
    }

    case quoteActions.GET_QUOTE_CART_PAYMENT_METHODS_START: {
      state.loadingPaymentMethods = true;
      break;
    }

    case quoteActions.GET_QUOTE_CART_PAYMENT_METHODS_SUCCESS: {
      state.quoteCartPaymentMethods = action.data;
      state.loadingPaymentMethods = false;
      break;
    }

    case quoteActions.GET_QUOTE_CART_PAYMENT_METHODS_FAILED: {
      state.loadingPaymentMethods = false;
      break;
    }

    case quoteActions.GET_QUOTE_CART_SHIPPING_METHODS_START: {
      state.loadingShippingMethods = true;
      break;
    }

    case quoteActions.GET_QUOTE_CART_SHIPPING_METHODS_SUCCESS: {
      state.quoteCartShippingMethods = action.data.filter((method) => method.carrier_code !== 'pickupatstore');
      state.quoteCartStorePickUpMethods = action.data.filter((method) => method.carrier_code === 'pickupatstore');
      state.loadingShippingMethods = false;
      break;
    }

    case quoteActions.GET_QUOTE_CART_SHIPPING_METHODS_FAILED: {
      state.loadingShippingMethods = false;
      break;
    }

    case quoteActions.GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_START: {
      state.loadingSelectedShippingMethod = true;
      break;
    }

    case quoteActions.GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_SUCCESS: {
      const {data} = action;
      state.quoteCartSelectedShippingMethod = data?.method_code ?
        {
          carrier_code: data?.carrier_code,
          method_code: data?.method_code
        }
        :
        {
          carrier_code: '',
          method_code: ''
        }
      ;
      state.loadingSelectedShippingMethod = false;
      break;
    }

    case quoteActions.GET_QUOTE_CART_SELECTED_SHIPPING_METHOD_FAILED: {
      state.loadingSelectedShippingMethod = false;
      break;
    }

    case quoteActions.SET_QUOTE_CART_SHIPPING_METHOD_START: {
      state.settingShippingMethods = true;
      break;
    }

    case quoteActions.SET_QUOTE_CART_SHIPPING_METHOD_SUCCESS: {
      state.settingShippingMethods = false;
      break;
    }

    case quoteActions.SET_QUOTE_CART_SHIPPING_METHOD_FAILED: {
      state.settingShippingMethods = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_TERMS_AND_CONDITIONS_START: {
      state.loadingTermsAndConditions = true;
      break;
    }

    case quoteActions.GET_QUOTEPRO_TERMS_AND_CONDITIONS_SUCCESS: {
      state.quoteCartTermsAndConditions = action.data;
      state.loadingTermsAndConditions = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_TERMS_AND_CONDITIONS_FAILED: {
      state.loadingTermsAndConditions = false;
      break;
    }

    case quoteActions.GET_TERMS_AND_CONDITIONS_LIST_START: {
      state.loadingTermsAndConditions = true;
      break;
    }

    case quoteActions.GET_TERMS_AND_CONDITIONS_LIST_SUCCESS: {
      const { data } = action;

      state.termsAndConditionsList = data.map((agreement) => {
        if (agreement.name.includes('Sarp ')) {
          agreement.name = agreement.name.replace('Sarp ', '');
          agreement.isSubscription = true;
        }

        const pattern = /<sup>|<\/sup>|<em class="required" style="display:inline-block; width: 10px;">\*<\/em>/gi;
        agreement.checkbox_text = agreement.checkbox_text.replaceAll(pattern, '');

        return agreement;
      });

      state.loadingTermsAndConditions = false;
      break;
    }

    case quoteActions.GET_TERMS_AND_CONDITIONS_LIST_FAILED: {
      state.loadingTermsAndConditions = false;
      break;
    }

    case quoteActions.DELETE_TERMS_AND_CONDITIONS_START: {
      state.loadingTermsAndConditions = true;
      break;
    }

    case quoteActions.DELETE_TERMS_AND_CONDITIONS_SUCCESS: {
      state.termsAndConditionsList =  state.termsAndConditionsList
        .filter((agreement) => agreement.agreement_id !== action.id);
      state.loadingTermsAndConditions = false;
      break;
    }

    case quoteActions.DELETE_TERMS_AND_CONDITIONS_FAILED: {
      state.loadingTermsAndConditions = false;
      break;
    }

    case quoteActions.SAVE_TERMS_AND_CONDITIONS_START: {
      state.loadingTermsAndConditions = true;
      break;
    }

    case quoteActions.SAVE_TERMS_AND_CONDITIONS_SUCCESS: {
      const { data: { data } } = action;

      const response = data;

      if (response.name.includes('Sarp ')) {
        response.name = response.name.replace('Sarp ', '');
        response.isSubscription = true;
      }

      state.termsAndConditionsList = state.termsAndConditionsList.map((item) => {
        if (item.agreement_id === response.agreement_id) {
          return data;
        }

        return item;
      });

      if (!state.termsAndConditionsList.some((item) => item.agreement_id === response.agreement_id)) {
        state.termsAndConditionsList.push(response);
      }

      state.loadingTermsAndConditions = false;
      break;
    }

    case quoteActions.SAVE_TERMS_AND_CONDITIONS_FAILED: {
      state.loadingTermsAndConditions = false;
      break;
    }

    case quoteActions.QUOTEPRO_PLACE_ORDER_COMBINED_START: {
      state.loadingPlaceOrder = true;
      break;
    }

    case quoteActions.QUOTEPRO_PLACE_ORDER_COMBINED_SUCCESS: {
      state.loadingPlaceOrder = false;
      break;
    }

    case quoteActions.QUOTEPRO_PLACE_ORDER_COMBINED_FAILED: {
      state.loadingPlaceOrder = false;
      break;
    }

    case quoteActions.UPDATE_EDITABLE_QUOTE_PRODUCT: {
      state.editableQuoteProduct = action.product;
      break;
    }

    case quoteActions.GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_START: {
      state.loadingQuoteProductSubscriptionOptions = true;
      break;
    }

    case quoteActions.GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_SUCCESS: {
      const {data, sku} = action;
      state.quoteProductSubscriptionOptions = data.items
        .sort((a, b) => Number(a.ssort_order) - Number(b.ssort_order));
      state.subscriptionOptionsBySku = {
        ...state.subscriptionOptionsBySku,
        [sku]: state.quoteProductSubscriptionOptions
      };
      state.loadingQuoteProductSubscriptionOptions = false;
      break;
    }

    case quoteActions.GET_QUOTE_PRODUCT_SUBSCRIPTION_OPTIONS_FAILED: {
      state.loadingQuoteProductSubscriptionOptions = false;
      break;
    }

    case quoteActions.DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_START: {
      state.quoteSubscriptionOptionsLoading = true;
      break;
    }

    case quoteActions.DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS: {
      state.quoteProductSubscriptionOptions =  state.quoteProductSubscriptionOptions
        .filter((o) => o.id !== action.id);
      state.subscriptionOptionsBySku = initialState.subscriptionOptionsBySku;
      state.quoteSubscriptionOptionsLoading = false;
      break;
    }

    case quoteActions.DELETE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED: {
      state.quoteSubscriptionOptionsLoading = false;
      break;
    }

    case quoteActions.UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_START: {
      state.quoteSubscriptionOptionsLoading = true;
      break;
    }
    case quoteActions.UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_SUCCESS: {
      if (action.isNewOptions) {
        const subscriptions = action.subscriptionsResult.map((result) => result.data);
        state.quoteProductSubscriptionOptions = [...state.quoteProductSubscriptionOptions, ...subscriptions];
      } else {
        state.quoteProductSubscriptionOptions = state.quoteProductSubscriptionOptions.map((option) => (
          option.id === action.subscriptionsResult.data.id
            ? action.subscriptionsResult.data
            : option
        ));
      }

      state.quoteSubscriptionOptionsLoading = false;
      break;
    }
    case quoteActions.UPDATE_QUOTE_PRODUCT_SUBSCRIPTION_OPTION_FAILED: {
      state.quoteSubscriptionOptionsLoading = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_ATTRIBUTE_DATA_START: {
      state.loadingQuoteProductAttributes = true;
      break;
    }

    case quoteActions.GET_QUOTEPRO_ATTRIBUTE_DATA_SUCCESS: {
      state.quoteProProductAttributeByCode = {...state.quoteProProductAttributeByCode, [action.attributeCode]: action.data.options};
      state.loadingQuoteProductAttributes = false;
      break;
    }

    case quoteActions.GET_QUOTEPRO_ATTRIBUTE_DATA_FAILED: {
      state.loadingQuoteProductAttributes = false;
      break;
    }

    case quoteActions.ADD_TO_MASS_EDIT: {
      const {products} = action;
      state.massEditList = products;
      break;
    }

    case quoteActions.GET_CUSTOMER_PUSH_CART_START: {
      state.loadingCustomerPushCart = true;
      break;
    }

    case quoteActions.GET_CUSTOMER_PUSH_CART_SUCCESS: {
      state.customerPushCart = action.data;
      state.loadingCustomerPushCart = false;
      break;
    }

    case quoteActions.GET_CUSTOMER_PUSH_CART_FAILED: {
      state.loadingCustomerPushCart = false;
      break;
    }

    case quoteActions.CREATE_CUSTOMER_PUSH_CART_START: {
      state.loadingCustomerPushCart = true;
      break;
    }

    case quoteActions.CREATE_CUSTOMER_PUSH_CART_SUCCESS: {
      state.customerPushCart = action.data.pushCart;
      state.loadingCustomerPushCart = false;
      break;
    }

    case quoteActions.CREATE_CUSTOMER_PUSH_CART_FAILED: {
      state.loadingCustomerPushCart = false;
      break;
    }

    case quoteActions.CONFIGURE_TREATMENT_PLAN: {
      state.quotePlan = state.customerPushCart.treatments.map((treatment) => {
        const selectedItems = treatment.selectedItemIds
          .map((id) => state.customerPushCart.selectedItems.find((i) => i._id === id));
        return {...treatment, selectedItems};
      });
      break;
    }

    case quoteActions.UPDATE_CUSTOMER_PUSH_CART_START: {
      state.loadingCustomerPushCart = true;
      break;
    }

    case quoteActions.UPDATE_CUSTOMER_PUSH_CART_SUCCESS: {
      state.customerPushCart = action.data.pushCart;
      state.loadingCustomerPushCart = false;

      const { treatments, selectedItems: pushCartItems } = action.data.pushCart;
      state.quotePlan = treatments.map((treatment) => ({
        ...treatment,
        selectedItems: treatment.selectedItemIds.map((id) => pushCartItems.find((i) => i._id === id)),
      })).sort((a, b) => (new Date(a.startDate).getTime()) - (new Date(b.startDate).getTime()));

      state.quotePlanSelectedSeriesIds = [];
      state.loadingCustomerPushCart = false;
      break;
    }

    case quoteActions.UPDATE_CUSTOMER_PUSH_CART_FAILED: {
      state.loadingCustomerPushCart = false;
      break;
    }

    case quoteActions.PUBLISH_PUSH_CART_ITEMS_START: {
      state.loadingCustomerPushCart = true;
      break;
    }

    case quoteActions.PUBLISH_PUSH_CART_ITEMS_SUCCESS: {
      state.customerPushCart = action.data;
      state.loadingCustomerPushCart = false;
      break;
    }

    case quoteActions.PUBLISH_PUSH_CART_ITEMS_FAILED: {
      state.loadingCustomerPushCart = false;
      break;
    }

    case quoteActions.PUBLISH_PUSHCART_TREATMENTS_START: {
      state.loadingCustomerPushCart = true;
      break;
    }

    case quoteActions.PUBLISH_PUSHCART_TREATMENTS_SUCCESS: {
      const {pushCart} = action.data;

      if (pushCart.status === 'PUBLISHED') {
        state.customerPushCart = null;
        state.quotePlan = [];
      } else {
        state.customerPushCart = pushCart;
        const { treatments, selectedItems: pushCartItems } = pushCart;
        state.quotePlan = treatments.map((treatment) => {
          const selectedItems = treatment.selectedItemIds.map((id) => pushCartItems.find((i) => i._id === id));
          return {...treatment, selectedItems};
        });
      }

      state.quotePlanSelectedSeriesIds = [];
      state.loadingCustomerPushCart = false;
      break;
    }

    case quoteActions.PUBLISH_PUSHCART_TREATMENTS_FAILED: {
      state.loadingCustomerPushCart = false;
      break;
    }

    case quoteActions.CREATE_PATIENTS_GROUP_QUOTE_START: {
      state.loadingPatientsGroupCart = true;
      break;
    }

    case quoteActions.CREATE_PATIENTS_GROUP_QUOTE_SUCCESS: {
      const { selectedItems } = action.data;
      const addedProducts = selectedItems.map((item) => item.sku);
      const updatedPatientsGroupCart = state.patientsGroupCart.filter(
        (p) => !addedProducts.includes(p.sku)
      );

      state.patientsGroupCart = updatedPatientsGroupCart;
      state.loadingPatientsGroupCart = false;
      break;
    }

    case quoteActions.CREATE_PATIENTS_GROUP_QUOTE_FAILED: {
      state.loadingPatientsGroupCart = false;
      break;
    }

    case quoteActions.CREATE_ACTIVE_CART_COMBINED_START: {
      state.loadingActiveMagentoCart = true;
      break;
    }

    case quoteActions.CREATE_ACTIVE_CART_COMBINED_SUCCESS: {
      state.activeMagentoCart = action.data;
      state.quotePlanSelectedSeriesIds = [];
      state.loadingActiveMagentoCart = false;
      break;
    }

    case quoteActions.CREATE_ACTIVE_CART_COMBINED_FAILED: {
      state.loadingActiveMagentoCart = false;
      break;
    }

    case quoteActions.GET_CUSTOMER_SUBSCRIPTIONS_START: {
      state.loadingCustomerSubscription = true;
      break;
    }

    case quoteActions.GET_CUSTOMER_SUBSCRIPTIONS_SUCCESS: {
      const { items } = action.data;
      state.customerSubscription = items;
      state.loadingCustomerSubscription = false;
      break;
    }

    case quoteActions.GET_CUSTOMER_SUBSCRIPTIONS_FAILED: {
      state.loadingCustomerSubscription = false;
      break;
    }

    case quoteActions.SET_FINAL_PAGE_DATA: {
      const { items, expirationDate } = action;
      state.finalPageData = {
        items,
        expirationDate
      };

      break;
    }

    case quoteActions.SET_PATIENTS_GROUP_CART: {
      const { patientsGroupCart } = action;
      state.patientsGroupCart = patientsGroupCart;

      break;
    }

    case quoteActions.UPDATE_QUOTE_PLAN_SELECTED_SERIES: {
      const {seriesId, isChecked} = action;

      if (isChecked) {
        state.quotePlanSelectedSeriesIds = [...state.quotePlanSelectedSeriesIds, seriesId];
      } else {
        state.quotePlanSelectedSeriesIds = state.quotePlanSelectedSeriesIds.filter((id) => id !== seriesId);
      }

      break;
    }

    case quoteActions.TOGGLE_SELECT_ALL_QUOTE_PLAN_SERIES: {
      if (action.isChecked) {
        state.quotePlanSelectedSeriesIds = state.quotePlan.map((series) => series._id);
      } else {
        state.quotePlanSelectedSeriesIds = [];
      }

      break;
    }

    case quoteActions.SET_QUOTE_PLAN_SERIES_NAME: {
      const {newName, seriesId} = action;

      state.quotePlan = state.quotePlan.map((series) => series.id === seriesId
        ? {...series, name: newName}
        : series
      );
      break;
    }

    case quoteActions.GET_TIMEZONE_CONFIG_START: {
      state.loadingTimezoneConfig = true;
      break;
    }

    case quoteActions.GET_TIMEZONE_CONFIG_SUCCESS: {
      state.storeTimezone = action.data?.config?.[0]?.value || 'America/Los_Angeles';
      state.loadingTimezoneConfig = false;
      break;
    }

    case quoteActions.GET_TIMEZONE_CONFIG_FAILED: {
      state.loadingTimezoneConfig = false;
      break;
    }

    case quoteActions.CREATE_QUOTE_PDF_PREVIEW_START: {
      state.loadingQuotePdfPreview = true;
      break;
    }

    case quoteActions.CREATE_QUOTE_PDF_PREVIEW_SUCCESS: {
      const { data } = action.data;

      state.quotePdfPreview = data.html;
      state.loadingQuotePdfPreview = false;
      break;
    }

    case quoteActions.CREATE_QUOTE_PDF_PREVIEW_FAILED: {
      state.loadingQuotePdfPreview = false;
      break;
    }

    case quoteActions.CREATE_DRAFT_QUOTE_START: {
      state.loadingDraftedQuotes = true;
      break;
    }

    case quoteActions.CREATE_DRAFT_QUOTE_SUCCESS: {
      const { pushCart, draftQuote } = action.data;
      state.customerPushCart = pushCart;
      state.quotePlan = pushCart.treatments.map((treatment) => {
        const selectedItems = treatment.selectedItemIds.map((id) => pushCart.selectedItems.find((i) => i._id === id));
        return {...treatment, selectedItems};
      });

      state.draftedQuotes = [...state.draftedQuotes, draftQuote];
      state.quotePlanSelectedSeriesIds = [];
      state.loadingDraftedQuotes = false;
      break;
    }

    case quoteActions.CREATE_DRAFT_QUOTE_FAILED: {
      state.loadingDraftedQuotes = false;
      break;
    }

    case quoteActions.GET_DRAFT_QUOTES_BY_CUSTOMER_START: {
      state.loadingDraftedQuotes = true;
      break;
    }

    case quoteActions.GET_DRAFT_QUOTES_BY_CUSTOMER_SUCCESS: {
      const { data } = action;

      state.draftedQuotes = data;
      state.loadingDraftedQuotes = false;
      break;
    }

    case quoteActions.GET_DRAFT_QUOTES_BY_CUSTOMER_FAILED: {
      state.loadingDraftedQuotes = false;
      break;
    }

    case quoteActions.OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_START: {
      state.loadingCheckout = true;
      break;
    }

    case quoteActions.OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_SUCCESS: {
      const { checkoutUrl } = action.data;
      window.location.href = checkoutUrl;
      state.selectedDraftedQuote = initialState.selectedDraftedQuote;
      state.loadingCheckout = false;
      break;
    }

    case quoteActions.OPEN_CHECKOUT_SERVICE_FOR_DRAFTED_QUOTE_FAILED: {
      state.loadingCheckout = false;
      break;
    }

    case quoteActions.PUBLISH_DRAFT_QUOTE_BY_ID_START: {
      state.loadingDraftedQuotes = true;
      break;
    }

    case quoteActions.PUBLISH_DRAFT_QUOTE_BY_ID_SUCCESS: {
      state.loadingDraftedQuotes = false;
      const { publishedDraftQuote } = action.data;

      state.draftedQuotes = state.draftedQuotes.filter((quote) => quote._id !== publishedDraftQuote._id);
      state.selectedDraftedQuote = initialState.selectedDraftedQuote;
      break;
    }

    case quoteActions.PUBLISH_DRAFT_QUOTE_BY_ID_FAILED: {
      state.loadingDraftedQuotes = false;
      break;
    }

    case quoteActions.CREATE_DRAFT_QUOTE_PDF_PREVIEW_START: {
      state.loadingDraftQuotePdfPreview = true;
      break;
    }

    case quoteActions.CREATE_DRAFT_QUOTE_PDF_PREVIEW_SUCCESS: {
      const { data } = action.data;
      state.draftQuotePdfPreview = data.html;
      state.loadingDraftQuotePdfPreview = false;
      break;
    }

    case quoteActions.CREATE_DRAFT_QUOTE_PDF_PREVIEW_FAILED: {
      state.loadingDraftQuotePdfPreview = false;
      break;
    }

    case quoteActions.CREATE_RECENT_QUOTE_PDF_PREVIEW_START: {
      state.loadingRecentQuotePdfPreview = true;
      break;
    }

    case quoteActions.CREATE_RECENT_QUOTE_PDF_PREVIEW_SUCCESS: {
      const { data } = action.data;
      state.recentQuotePdfPreview = data.html;
      state.loadingRecentQuotePdfPreview = false;
      break;
    }

    case quoteActions.CREATE_RECENT_QUOTE_PDF_PREVIEW_FAILED: {
      state.loadingRecentQuotePdfPreview = false;
      break;
    }

    case quoteActions.DOWNLOAD_DRAFT_QUOTE_PDF_START: {
      state.loadingDraftQuotePdfDownload = true;
      break;
    }

    case quoteActions.DOWNLOAD_DRAFT_QUOTE_PDF_SUCCESS: {
      state.loadingDraftQuotePdfDownload = false;
      break;
    }

    case quoteActions.DOWNLOAD_DRAFT_QUOTE_PDF_FAILED: {
      state.loadingDraftQuotePdfDownload = false;
      break;
    }

    case quoteActions.DOWNLOAD_RECENT_QUOTE_PDF_START: {
      state.loadingRecentQuotePdfDownload = true;
      break;
    }

    case quoteActions.DOWNLOAD_RECENT_QUOTE_PDF_SUCCESS: {
      state.loadingRecentQuotePdfDownload = false;
      break;
    }

    case quoteActions.DOWNLOAD_RECENT_QUOTE_PDF_FAILED: {
      state.loadingRecentQuotePdfDownload = false;
      break;
    }

    case quoteActions.UPDATE_DRAFT_QUOTE_BY_ID_START: {
      state.loadingDraftedQuotes = true;
      break;
    }

    case quoteActions.UPDATE_DRAFT_QUOTE_BY_ID_SUCCESS: {
      const { data } = action;

      state.draftedQuotes = state.draftedQuotes.map((quote) => quote._id === data._id ? data : quote);
      state.loadingDraftedQuotes = false;
      break;
    }

    case quoteActions.UPDATE_DRAFT_QUOTE_BY_ID_FAILED: {
      state.loadingDraftedQuotes = false;
      break;
    }

    case quoteActions.SET_SELECTED_DRAFTED_QUOTE: {
      const { selectedQuote } = action;

      state.draftQuotePdfPreview = initialState.draftQuotePdfPreview;
      state.recentQuotePdfPreview = initialState.recentQuotePdfPreview;
      state.selectedDraftedQuote = selectedQuote;
      break;
    }

    case quoteActions.DOWNLOAD_QUOTE_PDF_START: {
      state.loadingQuotePdfDownload = true;
      break;
    }

    case quoteActions.DOWNLOAD_QUOTE_PDF_SUCCESS: {
      state.loadingQuotePdfDownload = false;
      break;
    }

    case quoteActions.DOWNLOAD_QUOTE_PDF_FAILED: {
      state.loadingQuotePdfDownload = false;
      break;
    }

    case quoteActions.GET_DEAL_TASKS_START: {
      state.loadingDealTasks = true;
      break;
    }

    case quoteActions.GET_DEAL_TASKS_SUCCESS: {
      const {data: {tasks}, dealId} = action;
      state.dealTasks[dealId] = tasks;
      state.loadingDealTasks = false;
      break;
    }

    case quoteActions.GET_DEAL_TASKS_FAILED: {
      state.loadingDealTasks = false;
      break;
    }

    case quoteActions.CREATE_DEAL_TASK_START: {
      state.loadingDealTasks = true;
      break;
    }

    case quoteActions.CREATE_DEAL_TASK_SUCCESS: {
      const {data} = action;
      const {dealId} = data.task;

      const currentTasks = state.dealTasks[dealId] || [];
      currentTasks.unshift(data.task);
      state.dealTasks[dealId] = currentTasks;
      state.allTasks.unshift(data.task);
      state.allTasks.pop();
      state.tasksTotalCount = state.tasksTotalCount + 1;

      state.loadingDealTasks = false;
      break;
    }

    case quoteActions.CREATE_DEAL_TASK_FAILED: {
      state.loadingDealTasks = false;
      break;
    }

    case quoteActions.UPDATE_DEAL_TASK_START: {
      state.loadingDealTasks = true;
      break;
    }

    case quoteActions.UPDATE_DEAL_TASK_SUCCESS: {
      const { data } = action;
      const { dealId, _id } = data.task;

      const currentTasks = state.dealTasks[dealId] || [];
      const updatedTasks = currentTasks.map((task) => task._id === _id ? data.task : task);

      state.dealTasks[dealId] = updatedTasks;
      state.allTasks = state.allTasks.map((task) => task._id === _id ? data.task : task);
      state.loadingDealTasks = false;
      break;
    }

    case quoteActions.UPDATE_DEAL_TASK_FAILED: {
      state.loadingDealTasks = false;
      break;
    }

    case quoteActions.DELETE_DEAL_TASK_START: {
      state.loadingDealTasks = true;
      break;
    }

    case quoteActions.DELETE_DEAL_TASK_SUCCESS: {
      const { id, dealId } = action;

      const currentTasks = state.dealTasks[dealId] || [];
      state.dealTasks[dealId] = currentTasks.filter((task) => task._id !== id);
      state.allTasks = state.allTasks.filter((task) => task._id !== id);
      state.tasksTotalCount = state.tasksTotalCount - 1;
      state.loadingDealTasks = false;
      break;
    }

    case quoteActions.DELETE_DEAL_TASK_FAILED: {
      state.loadingDealTasks = false;
      break;
    }

    case quoteActions.GET_DEAL_ACTIVITIES_START: {
      state.loadingDealActivities = true;
      break;
    }

    case quoteActions.GET_DEAL_ACTIVITIES_SUCCESS: {
      const {data: {activities}, dealId} = action;
      state.dealActivities[dealId] = activities;
      state.loadingDealActivities = false;
      break;
    }

    case quoteActions.GET_DEAL_ACTIVITIES_FAILED: {
      state.loadingDealActivities = false;
      break;
    }

    case quoteActions.CREATE_DEAL_ACTIVITY_START: {
      state.loadingDealActivities = true;
      break;
    }

    case quoteActions.CREATE_DEAL_ACTIVITY_SUCCESS: {
      const {data} = action;
      const {dealId} = data.activity;

      const currentActivities = state.dealActivities[dealId] || [];
      currentActivities.unshift(data.activity);
      state.dealActivities[dealId] = currentActivities;
      state.allActivities.unshift(data.activity);
      state.allActivities.pop();
      state.activitiesTotalCount = state.activitiesTotalCount + 1;

      state.loadingDealActivities = false;
      break;
    }

    case quoteActions.CREATE_DEAL_ACTIVITY_FAILED: {
      state.loadingDealActivities = false;
      break;
    }

    case quoteActions.UPDATE_DEAL_ACTIVITY_START: {
      state.loadingDealActivities = true;
      break;
    }

    case quoteActions.UPDATE_DEAL_ACTIVITY_SUCCESS: {
      const { data } = action;
      const { dealId, _id } = data.activity;

      const currentActivities = state.dealActivities[dealId] || [];
      const updatedActivities = currentActivities.map((activity) => activity._id === _id ? data.activity : activity);
      state.allActivities = state.allActivities.map((activity) => activity._id === _id ? data.activity : activity);

      state.dealActivities[dealId] = updatedActivities;
      state.loadingDealActivities = false;
      break;
    }

    case quoteActions.UPDATE_DEAL_ACTIVITY_FAILED: {
      state.loadingDealActivities = false;
      break;
    }

    case quoteActions.DELETE_DEAL_ACTIVITY_START: {
      state.loadingDealActivities = true;
      break;
    }

    case quoteActions.DELETE_DEAL_ACTIVITY_SUCCESS: {
      const { id, dealId } = action;

      const currentActivities = state.dealActivities[dealId] || [];
      state.dealActivities[dealId] = currentActivities.filter((activity) => activity._id !== id);
      state.allActivities = state.allActivities.filter((activity) => activity._id !== id);
      state.activitiesTotalCount = state.activitiesTotalCount - 1;
      state.loadingDealActivities = false;
      break;
    }

    case quoteActions.DELETE_DEAL_ACTIVITY_FAILED: {
      state.loadingDealActivities = false;
      break;
    }

    case quoteActions.GET_ALL_TASKS_START: {
      state.loadingDealTasks = true;
      break;
    }

    case quoteActions.GET_ALL_TASKS_SUCCESS: {
      const { data } = action;

      state.allTasks = data.tasks;
      state.tasksTotalCount = data.totalCount;
      state.loadingDealTasks = false;
      break;
    }

    case quoteActions.GET_ALL_TASKS_FAILED: {
      state.loadingDealTasks = false;
      break;
    }

    case quoteActions.GET_ALL_ACTIVITIES_START: {
      state.loadingDealActivities = true;
      break;
    }

    case quoteActions.GET_ALL_ACTIVITIES_SUCCESS: {
      const { data } = action;

      state.allActivities = data.activities;
      state.activitiesTotalCount = data.totalCount;
      state.loadingDealActivities = false;
      break;
    }

    case quoteActions.GET_ALL_ACTIVITIES_FAILED: {
      state.loadingDealActivities = false;
      break;
    }

    case quoteActions.CANCEL_QUOTE_START: {
      state.loadingCustomerAmastyQuotes = true;
      break;
    }

    case quoteActions.CANCEL_QUOTE_SUCCESS: {
      const { quoteId } = action;
      state.customerAmastyQuotes = state.customerAmastyQuotes.map((quote) =>
        quote.id === quoteId ? { ...quote, status: '4' } : quote
      );
      state.loadingCustomerAmastyQuotes = false;
      break;
    }

    case quoteActions.CANCEL_QUOTE_FAILED: {
      state.loadingCustomerAmastyQuotes = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
